import { END_POINTS } from "../constants/url";
import { RefundData, WalletData } from "../types/General";

import emptySplitApi from "../utils/rtk";

type CommonResponseType = {
  statusCode: number;
  message: string;
  data: WalletData[];
};
type WalletRefund = {
  bookingId: string;
};

export const WalletApi = emptySplitApi.injectEndpoints({
  endpoints: (builder) => ({
    getWalletList: builder.query<
      CommonResponseType,
      {
        page: number;
        limit: number;
        search: string;
        status: number;
      }
    >({
      query: ({ page, limit, search, status }) => ({
        url: `${
          END_POINTS.walletList
        }?status=${status}&page=${page}&limit=${limit}${
          search ? `&search=${search}` : ""
        }`,
        method: "GET",
      }),
    }),
    addWalletRefund: builder.mutation<
      CommonResponseType,
      { data: WalletRefund }
    >({
      query: (body) => ({
        url: END_POINTS.walletRefund,
        method: "POST",
        body: body?.data,
      }),
    }),
  }),
});
export const { useLazyGetWalletListQuery, useAddWalletRefundMutation } =
  WalletApi;
